import { CompanyDetailAndJobGroups, OgpCompanyType } from '@types';
import { isLimitedOgpCompany } from 'ogp/limited-company-capabilities';
import { cloneSidebarItems } from './clone-sidebar-items';
import { filterCollegialLendingSidebarItems } from './filter-collegial-lending-sidebar-items';
import { filterManagementAdminSettingsSidebarItems } from './filter-management-admin-settings-sidebar-items';
import { filterManagementWorkflowsSidebarItems } from './filter-management-workflows-sidebar-items';
import { filterSidebarItemsForLimitedCompany } from './filter-sidebar-items-for-limited-company';
import { filterWorkforceManagementSidebarItems } from './filter-workforce-management-sidebar-items';
import { useSidebarItems } from '../sidebar-items';

export const filterOutSidebarItems = ({
  sidebarItems,
  company,
  allowWorkflows,
  allowCollegialLending,
  companyRoles,
  companyType,
}: {
  sidebarItems: ReturnType<typeof useSidebarItems>;
  company: CompanyDetailAndJobGroups | undefined;
  allowWorkflows: boolean;
  allowCollegialLending: boolean;
  companyRoles: string[] | undefined;
  companyType?: OgpCompanyType;
}) => {
  const resolvedCompanyType = companyType ?? company?.company.companyType;

  if (isLimitedOgpCompany(resolvedCompanyType)) {
    return filterSidebarItemsForLimitedCompany(sidebarItems);
  }

  let result = cloneSidebarItems(sidebarItems);
  result = filterWorkforceManagementSidebarItems(result, company?.company.offersEmployeeWork);
  result = filterManagementAdminSettingsSidebarItems(result, companyRoles);
  result = filterManagementWorkflowsSidebarItems(result, { companyRoles, allowWorkflows });
  result = filterCollegialLendingSidebarItems(result, allowCollegialLending);

  return result;
};
